import { AppRoutes } from 'modules/shop/routes';
import { PageType } from 'modules/stroyblok/types';
import { ClientPageType } from 'src/app/types';
import { gtmPushVirtualUrl } from './page';

const virtualUrlsMap: Record<string, string> = {
  [AppRoutes.HOME]: '/startseite',
  [AppRoutes.CART]: '/cart',
  [AppRoutes.CHECKOUT_AUTH]: '/order_oco_login',
  [AppRoutes.KASSE]: '/order_oco_address',
  [AppRoutes.PAYMENT]: '/order_oco_payment',
  [AppRoutes.CONFIRMATION]: '/order_oco_checkout',
  [`${AppRoutes.CHECKOUT}/success`]: '/order_oco_success',
};

export const getRelevantVirtualUrl = (
  pathname: string,
  searchParams?: string,
) => {
  /** return correct virtual url for product */
  if (pathname.startsWith('/p/')) {
    const referenceKey = pathname.split('-').at(-1);
    return `/p/${referenceKey}`;
  }

  let url = virtualUrlsMap[pathname] || pathname;

  if (searchParams) {
    url = `${url}?${searchParams}`;
  }

  return url;
};

export const gtmPushRelevantVirtualUrl = (
  pathname: string,
  searchParams?: string,
) => {
  gtmPushVirtualUrl(getRelevantVirtualUrl(pathname, searchParams));
};

const CATEGORY_SEPARATOR = ' > ';

export const parseCategoryPathname = (
  pathname: string,
  lastSliceIndex: number = 1,
) => {
  return pathname
    .split('/')
    .filter(Boolean) // remove empty items
    .slice(0, -lastSliceIndex) // remove part which contains in breadcrumbs
    .map((item) =>
      item
        .split('-')
        .map((str) => str[0].toUpperCase() + str.slice(1).toLowerCase())
        .join(' '),
    )
    .join(CATEGORY_SEPARATOR);
};

export const getRelevantCategoryPath = (
  items: string[],
  pathname: string = '',
  pageType?: PageType,
) => {
  switch (pageType) {
    case ClientPageType.CATEGORY:
      return `${parseCategoryPathname(pathname, items.length)} > ${items.join(CATEGORY_SEPARATOR)}`;
    case ClientPageType.PDP:
      /** slice needs here to remove product name from breadcrumbs */
      return items.slice(0, -1).join(CATEGORY_SEPARATOR);
    default:
      return items.join(CATEGORY_SEPARATOR);
  }
};
